import React from 'react'
import { Typography, Box } from '@mui/material'

const TestPage: React.FC = () => {
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Test Page - React is Working!
      </Typography>
      <Typography variant="body1">
        If you can see this page, React and Material-UI are working correctly.
      </Typography>
      <Typography variant="body2" sx={{ mt: 2 }}>
        Current time: {new Date().toLocaleString()}
      </Typography>
    </Box>
  )
}

export default TestPage
